import api from "./api";

const urls = new Map();
let audio = null;
let currentKey = null;
const listeners = new Set();

const emit = () => listeners.forEach((fn) => fn(currentKey));

export const onPlaybackChange = (fn) => { listeners.add(fn); return () => listeners.delete(fn); };

export const stopAudio = () => {
  if (audio) { audio.pause(); audio = null; }
  currentKey = null;
  emit();
};

export const voiceErrorMessage = async (e) => {
  const d = e.response?.data;
  if (d instanceof Blob) {
    try { return JSON.parse(await d.text()).detail?.message || "Could not play audio"; } catch { return "Could not play audio"; }
  }
  return d?.detail?.message || "Could not play audio";
};

// Resolves when playback ends (or is stopped).
export async function playText(text, key = text) {
  stopAudio();
  let url = urls.get(text);
  if (!url) {
    const { data } = await api.post("/voice/tts", { text }, { responseType: "blob" });
    url = URL.createObjectURL(data);
    urls.set(text, url);
  }
  const el = new Audio(url);
  audio = el;
  currentKey = key;
  emit();
  return new Promise((resolve) => {
    const done = () => { if (audio === el) { audio = null; currentKey = null; emit(); } resolve(); };
    el.onended = done;
    el.onpause = done;
    el.onerror = done;
    el.play().catch(done);
  });
}

export async function transcribe(blob) {
  const form = new FormData();
  const ext = blob.type.includes("mp4") ? "m4a" : blob.type.includes("ogg") ? "ogg" : "webm";
  form.append("audio", blob, `recording.${ext}`);
  const { data } = await api.post("/voice/stt", form);
  return data.text;
}
